import { getLogger } from 'oasis-os-common';
import { ApplicationConfig } from '../types';

const logger = getLogger(PKG_NAME, PKG_VERSION, 'Transformer');

export const transformer = (
  { urlConfig, functionalConfig, authConfig, imglyLicense }: ApplicationConfig['fields'],
  smHost?: string | undefined,
  swIntercept = true,
): Record<string, unknown> => {
  const { service, appUrls } = urlConfig;
  let newService = { ...service.others };
  const servicePath = { ...service.path };
  if (smHost) {
    const multiDc = service.multiDc[smHost];
    (Array.isArray(multiDc) ? multiDc : [multiDc]).forEach((container) => {
      newService[container] = smHost;
    });
    newService = { ...newService, smHost };
  }

  Object.keys(servicePath).forEach((key) => {
    if (key in newService) {
      newService[key] += servicePath[key];
    } else if (key.split('_')[0] in newService) {
      newService[key] = newService[key.split('_')[0]] + servicePath[key];
    } else {
      logger.error('No mapping found for new service key ', key);
    }
  });

  authConfig = {
    auth: {
      ...authConfig.auth,
      host: urlConfig.appUrls.host,
      clientUrl: urlConfig.appUrls.clientUrl,
      swIntercept,
    },
    authPin: {
      ...authConfig.authPin,
      authority: urlConfig.appUrls.authority,
      redirect_uri: urlConfig.appUrls.redirect_uri,
    },
  };

  return {
    service: { ...newService, ...appUrls, updated: false },
    functionalConfig,
    authConfig,
    imglyLicense: imglyLicense?.fields?.file?.url,
  };
};
